import { useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let answers = useDataValue({
    viewPath: props.viewPath,
    context: 'selected',
    path: 'answers',
  })

  let phoneDetails = useDataValue({
    viewPath: props.viewPath,
    context: 'contactDetails',
    path: 'phoneDetails',
  })

  let setPhoneDetails = useDataChange({
    viewPath: props.viewPath,
    context: 'contactDetails',
    path: 'phoneDetails',
  })

  return function onClick(value) {
    let patientPhoneDetails = answers['patient.contactDetails']['phoneDetails']

    setPhoneDetails({
      ...phoneDetails,
      phoneType: value
        ? patientPhoneDetails?.phoneType
        : phoneDetails?.phoneType,
      phoneNumber: value
        ? patientPhoneDetails?.phoneNumber
        : phoneDetails?.phoneNumber,
      responsiblePersonPhoneDetails: {
        usePatientPhone: value,
      },
    })
  }
}
